
An ongoing exploration into neural networks with the end goal of understanding audio analysis at a deeper level. These are living notes — definitions, network types, and the building blocks for eventually applying ML to music data.

# intro to neural networks

## definitions

*features:*

*weights:*

*activation function:*
- we add positive features and subtract negative features multiplied by their weight
- have to pick a normalization function too (i.e. sigmoid, etc)

*neuron:*
1. takes the inputs and multiplies them by their weights
2. sums them up
3. applies the activation function to the sum

## types

### feedforward

- data passes through the different input nodes till it reaches the output node
  - moves in only one direction from the first tier onwards until it reaches the output node
  - this is also known as a front propagated wave which is usually achieved by using a classifying activation function
- the sum of the products of the inputs and their weights are calculated

### radial basis

- distance of any point relative to the centre
- 2 layers
  - inner: the features are combined with the radial basis function
  - output of these features is taken into account when calculating the same output in the next time-step
